import { FC } from 'react';
import type { ViewMode, TherapistAppointment } from './types';

interface ScheduleSummaryProps {
  viewMode: ViewMode;
  appointments: TherapistAppointment[];
}

export const ScheduleSummary: FC<ScheduleSummaryProps> = ({ viewMode, appointments }) => {
  const periodLabel =
    viewMode === 'day' ? "Today's" : viewMode === 'week' ? "This Week's" : "This Month's";

  const confirmedCount = appointments.filter((a) => a.status === 'confirmed').length;
  const completedCount = appointments.filter((a) => a.status === 'completed').length;
  const cancelledCount = appointments.filter((a) => a.status === 'cancelled').length;

  return (
    <div className="bg-gray-50 dark:bg-slate-800/50 rounded-lg p-4 border border-gray-200 dark:border-slate-700">
      <h3 className="font-medium text-gray-900 dark:text-slate-100 mb-3">{periodLabel} Summary</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
        <div>
          <p className="text-gray-500 dark:text-slate-400">Total</p>
          <p className="text-xl font-bold text-gray-900 dark:text-slate-100">
            {appointments.length}
          </p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Confirmed</p>
          <p className="text-xl font-bold text-blue-600 dark:text-blue-400">{confirmedCount}</p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Completed</p>
          <p className="text-xl font-bold text-green-600 dark:text-green-400">{completedCount}</p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Cancelled</p>
          <p className="text-xl font-bold text-red-600 dark:text-red-400">{cancelledCount}</p>
        </div>
      </div>
    </div>
  );
};
